import React from 'react';

import './gauge.scss';

interface GaugeProps {
  className?: string;
  value?: string | number;
}

function Gauge(props: GaugeProps) {
  const { className, value } = props;

  return (
    <div className={`gauge ${className || ''}`} styleName="container">
      <span
        className="gauge__value"
        data-testid="gauge-value"
        styleName="value"
      >
        {Number.isInteger(value) ? `${value}.0` : value}
      </span>
      <span
        className="gauge__label"
        data-testid="gauge-label"
        styleName="label"
      >
        out of 5
      </span>
    </div>
  );
}

export default Gauge;
